const actions = {
  ADD_ENG_BEGIN: 'ADD_ENG_BEGIN',
  ADD_ENG_SUCCESS: 'ADD_ENG_SUCCESS',
  ADD_ENG_ERR: 'ADD_ENG_ERR',

  ADD_VENDOR_ENG_BEGIN: 'ADD_VENDOR_ENG_BEGIN',
  ADD_VENDOR_ENG_SUCCESS: 'ADD_VENDOR_ENG_SUCCESS',
  ADD_VENDOR_ENG_ERR: 'ADD_VENDOR_ENG_ERR',

  GET_ENG_BEGIN: 'GET_ENG_BEGIN',
  GET_ENG_SUCCESS: 'GET_ENG_SUCCESS',
  GET_ENG_ERR: 'GET_ENG_ERR',

  GET_VENDOR_ENG_BEGIN: 'GET_VENDOR_ENG_BEGIN',
  GET_VENDOR_ENG_SUCCESS: 'GET_VENDOR_ENG_SUCCESS',
  GET_VENDOR_ENG_ERR: 'GET_VENDOR_ENG_ERR',

  DELETE_ENG_BEGIN: 'DELETE_ENG_BEGIN',
  DELETE_ENG_SUCCESS: 'DELETE_ENG_SUCCESS',
  DELETE_ENG_ERR: 'DELETE_ENG_ERR',

  UPDATE_ENG_BEGIN: 'UPDATE_ENG_BEGIN',
  UPDATE_ENG_SUCCESS: 'UPDATE_ENG_SUCCESS',
  UPDATE_ENG_ERR: 'UPDATE_ENG_ERR',

  AddBegin: () => {
    return {
      type: actions.ADD_ENG_BEGIN,
    };
  },

  AddSuccess: (data) => {
    return {
      type: actions.ADD_ENG_SUCCESS,
      data,
    };
  },

  AddErr: (err) => {
    return {
      type: actions.ADD_VENDOR_ENG_ERR,
      err,
    };
  },

  AddVendorEngBegin: () => {
    return {
      type: actions.ADD_VENDOR_ENG_BEGIN,
    };
  },

  AddVendorEngSuccess: (data) => {
    return {
      type: actions.ADD_VENDOR_ENG_SUCCESS,
      data,
    };
  },

  AddVendorEngErr: (err) => {
    return {
      type: actions.ADD_ENG_ERR,
      err,
    };
  },

  ReadBegin: () => {
    return {
      type: actions.GET_ENG_BEGIN,
    };
  },

  ReadSuccess: (data) => {
    return {
      type: actions.GET_ENG_SUCCESS,
      data,
    };
  },

  ReadErr: (err) => {
    return {
      type: actions.GET_ENG_ERR,
      err,
    };
  },

  ReadVendorEngBegin: () => {
    return {
      type: actions.GET_VENDOR_ENG_BEGIN,
    };
  },

  ReadVendorEngSuccess: (data) => {
    return {
      type: actions.GET_VENDOR_ENG_SUCCESS,
      data,
    };
  },

  ReadVendorEngErr: (err) => {
    return {
      type: actions.GET_VENDOR_ENG_ERR,
      err,
    };
  },

  UpdateBegin: () => {
    return {
      type: actions.UPDATE_ENG_BEGIN,
    };
  },

  UpdateSuccess: (data) => {
    return {
      type: actions.UPDATE_ENG_SUCCESS,
      data,
    };
  },

  UpdateErr: (err) => {
    return {
      type: actions.UPDATE_ENG_ERR,
      err,
    };
  },

  DeleteBegin: () => {
    return {
      type: actions.DELETE_ENG_BEGIN,
    };
  },

  DeleteSuccess: (data) => {
    return {
      type: actions.DELETE_ENG_SUCCESS,
      data,
    };
  },

  DeleteErr: (err) => {
    return {
      type: actions.DELETE_ENG_ERR,
      err,
    };
  },
};

export default actions;
